import React, { useCallback, useEffect } from "react";
import useApiHouse from "../api/useApiHouse";
import { useSelector, useDispatch } from "react-redux";
import { initializeHeaderTab } from "../slices/headerSlice";
import { initializeEntryLineDetailTab } from "../slices/entryLineDetailSlice";
import { initializeEntrySummaryTab } from "../slices/entrySummarySlice";
import { statusDetailPayload } from "../api/apiPayloads";
import { setLoader } from "../slices/loaderSlice";
import { initializeStatusDetail } from "../slices/statusDetailSlice";
import { updateCurrentJob } from "../slices/currentJobSlice";

const useStatusDetail = () => {
    const [getStatusDetailData, {data: statusDetailData, isLoading: statusDetailLoading, error: statusDetailErr}] = useApiHouse();
    const {currentJob: {reconShipmentId}} = useSelector((state) => state.currentJob)
    const dispatch = useDispatch();
    const getStatusDetail = () => {
        getStatusDetailData(statusDetailPayload(reconShipmentId));
        dispatch(setLoader({path: "statusDetailLoader.statusDetailListLoader", value: true}))
    }
    useEffect(() => {
        if(!statusDetailLoading && statusDetailData){
            dispatch(initializeStatusDetail(statusDetailData.eventMessage?.reconCbpRequestResponses))
            dispatch(setLoader({path: "statusDetailLoader.statusDetailListLoader", value: false}))
            dispatch(updateCurrentJob({reconShipmentStatus: statusDetailData.eventMessage?.jobStatus}));
            if(statusDetailData.eventMessage?.reconCbpRequestResponses)
                dispatch(updateCurrentJob({reconCbpStatus: statusDetailData.eventMessage?.reconCbpRequestResponses[0]?.cbpStatus}));
        }
        else if(statusDetailErr){
            dispatch(initializeStatusDetail(statusDetailErr.eventMessage?.response))
        }
    }, [statusDetailData, statusDetailLoading, statusDetailErr])
    return { getStatusDetail };
}
 
export default useStatusDetail;